import React from "react";
import { Dialog, DialogContent, DialogActions, Typography, Button } from "@mui/material";

/**
 * RemindDialog - Reusable confirmation dialog for WhatsApp reminders
 * Styled to match the logout popup UI
 */
const RemindDialog = ({ isOpen, onClose, onConfirm, message }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="remind-dialog-title"
      aria-describedby="remind-dialog-description"
      PaperProps={{
        sx: {
          width: { xs: "90%", sm: "600px" },
          maxWidth: { xs: "calc(100vw - 32px)", sm: "600px" },
          minHeight: "192px",
          borderRadius: "12px",
          backgroundColor: "#FFFFFF",
          padding: { xs: "16px 20px", sm: "20px 32px" },
          boxShadow: "none",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        },
      }}
    >
      {/* Message */}
      <DialogContent sx={{ padding: 0 }}>
        <Typography
          id="remind-dialog-description"
                      sx={{
              fontFamily: "Roboto",
              fontWeight: 400,
              fontSize: { xs: "16px", sm: "20px" },
              lineHeight: { xs: "20px", sm: "24px" },
              color: "#212121",
              textAlign: "left",
              letterSpacing: "0.01em",
              mt: "16px",
            }}
        >
          {message || "Send reminder via WhatsApp?"}
        </Typography>
      </DialogContent>

      <DialogActions sx={{
        justifyContent: "flex-end", 
        padding: 0, 
        marginTop: { xs: "12px", sm: "16px" }, 
        gap: { xs: 2.5, sm: "20px" },
        display: "flex",
        width: "100%"
      }}>
        {/* Cancel Button */}
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            flex: { xs: 1, sm: "none" },
            width: { xs: "auto", sm: "120px" },
            height: { xs: "22px", sm: "44px" },
            borderRadius: { xs: "4px", sm: "8px" },
            borderColor: "#F04438",
            color: "#F04438",
            background: "#fff",
            fontFamily: "Roboto",
            fontWeight: 500,
            fontSize: { xs: "10px", sm: "16px" },
            lineHeight: { xs: "12px", sm: "24px" },
            letterSpacing: "0.01em",
            textTransform: "none",
            padding: { xs: "2px 4px", sm: "auto" },
            minWidth: { xs: 0, sm: "auto" },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            "&:hover": {
              borderColor: "#F04438",
              background: "#FFF3F2",
            },
          }}
        >
          Cancel
        </Button>

        {/* Remind Button - WhatsApp themed */}
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            flex: { xs: 1, sm: "none" },
            width: { xs: "auto", sm: "120px" },
            height: { xs: "22px", sm: "44px" },
            borderRadius: { xs: "4px", sm: "8px" },
            backgroundColor: '#0063F7 !important',
            color: '#FFFFFF !important',
            fontFamily: 'Roboto',
            fontWeight: 500,
            textTransform: 'none',
            fontSize: { xs: "10px", sm: "16px" },
            lineHeight: { xs: "12px", sm: "24px" },
            letterSpacing: "0.01em",
            padding: { xs: "2px 4px", sm: "auto" },
            minWidth: { xs: 0, sm: "auto" },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            '&:hover': {
              backgroundColor: '#0063F7 !important',
              color: '#FFFFFF !important',
              boxShadow: 10
            }
          }}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemindDialog;
